import { CommonFilterWithPaginator } from '@models/filters/common-filter-with-paginator';

export const prepareFilter = <T = CommonFilterWithPaginator>(filter: T, joinArrays = false): ObjectItem => {
  const params: ObjectItem = {};
  const timeRgx = /(\d{4}-\d{2}-\d{2}|\d{2}:\d{2})/;
  Object.keys({ ...filter }).forEach((key) => {
    if (filter[key] !== undefined && filter[key] !== null && filter[key] !== '' && key !== 'fromTimeKey' && key !== 'toTimeKey') {
      if (filter[key] instanceof Date || timeRgx.test(filter[key])) {
        params[key] = new Date(filter[key]).getTime();
        return;
      }
      if (Array.isArray(filter[key])) {
        if (filter[key].length > 0 && !joinArrays) {
          params[key] = JSON.stringify(filter[key]);
        } else {
          params[key] = filter[key].join(',');
        }
        return;
      }
      params[key] = String(filter[key]);
    }
  });

  return params;
};

export interface ObjectItem {
  [key: string]: any;
}
